<template>
    <div>
        <Head :title="`${form.name}`"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('f-types.index')"
            >
                Види риболовлі без місця
            </Link>
            <span class="text-indigo-400 font-medium">/</span>
            {{ form.name }}
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update" enctype="multipart/form-data">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full"
                                    label="Назва"/>
                        <select-input v-model="form.lake_id" :error="form.errors.lake_id" class="pb-8 pr-6 w-full"
                                      label="Озеро">
                            <option :value="null"/>
                            <option v-for="lake in lakes" :key="lake.id" :value="lake.id">{{ lake.name }}</option>
                        </select-input>
                        <text-input v-model="form.price" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Ціна"/>
                        <text-input v-model="form.day_limit" :error="form.errors.day_limit" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Ліміт на день"/>
                        <textarea-input v-model="form.short_description" :error="form.errors.short_description"
                                        class="pb-8 pr-6 w-full" label="Короткий опис"/>
                        <div class="pb-8 pr-6 w-full">
                            <label class="form-label" for="description">Опис</label>
                            <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"
                                      id="description" class="description"/>
                        </div>
                        <drag-and-drop
                            v-model="form.images"
                            :error="form.errors.images"
                            class="pb-8 pr-6 w-full lg:w-1/2"
                            type="file"
                            accept="image/*"
                            label="Зображення"
                        />
                    </div>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button
                        class="text-red-600 hover:underline" tabindex="-1" type="button"
                        @click="destroy"
                    >
                        Видалити
                    </button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Оновити
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout.vue'
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import DragAndDrop from "@/Shared/DragAndDrop.vue"
import TextareaInput from "@/Shared/TextareaInput.vue"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import CKEditor from "@ckeditor/ckeditor5-vue"

export default {
    components: {
        TextareaInput,
        DragAndDrop,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        ckeditor: CKEditor.component
    },
    layout: Layout,
    props: {
        fast_order_type: Object,
        lakes: Array
    },
    remember: 'form',
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            form: this.$inertia.form({
                _method: 'put',
                name: this.fast_order_type.name,
                description: this.fast_order_type.description,
                images: null,
                short_description: this.fast_order_type.short_description,
                price: this.fast_order_type.price,
                lake_id: this.fast_order_type.lake_id,
                day_limit: this.fast_order_type.day_limit,
            }),
        }
    },
    methods: {
        update() {
            this.form.post(this.$route('f-types.update',this.fast_order_type.id))
        },
        destroy() {
            if (confirm('Ви впевнені що хочете видалити тариф?')) {
                this.$inertia.delete(this.$route('f-types.destroy',this.fast_order_type.id))
            }
        }
    },
}
</script>

<style scoped>
:deep(.ck.ck-editor__editable_inline) {
    min-height: 500px;
}

.description {
    width: 100%;
    min-width: 100%;
}
</style>
